import clsx from 'clsx'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

import { ColorCardProps } from '@/components/ColorCard/ColorCard.type'
import Heading from '@/components/Heading'
import Picture from '@/components/Picture'

import styles from './ColorCard.module.scss'

const ColorCard: FC<ColorCardProps> = ({
  className = '',
  heading = null,
  summary = null,
  id,
  image
}) => {
  const {
    i18n: { language }
  } = useTranslation()

  return (
    <div
      className={clsx(
        styles['color-card'],
        className,
        styles[`color-card_${id}`]
      )}
    >
      <div className={styles['color-card__fig']}>
        <Picture
          src={`/images/color-card/${language}/${id}/${image}`}
          alt={heading || ''}
          className={styles['color-card__img']}
        />
      </div>
      <Heading level={2} className={styles['color-card__heading']}>
        {heading}
      </Heading>
      {summary && (
        <div
          className={styles['color-card__summary']}
          dangerouslySetInnerHTML={{ __html: summary }}
        />
      )}
    </div>
  )
}
export default ColorCard
